import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catastro/colindancias-de-predios/';

/**
 * GET Colindancia
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getColindancias = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Colindancia
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getColindancia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};
/**
 *
 * @param {object} values
 *
 * @returns {Promise<object|boolean>}
 */
export const postColindancia = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const patchColindancia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const deleteColindancia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
